import { useRef, useState } from "react";
import Title, { ConfirmPassword, ConfirmPin, Email, FirstNameLastName, Message, Mobile, SingleButton, SubmitClearButton, TermsCheckBox } from "./LoginUtil";
import { encrypt, handleInput, handleReset } from "../Common/Util";
import { validateConfirmPassword, validateConfirmPin, validateEmail, validateMobile, validateName, validateTermsCheckBox } from "./LoginValidate";
import { axiosErrorHandler, axiosPost, axiosResponseHandler } from "../Common/axios";
import { Captcha } from "../Common/Captcha";

export function Signup () {
    const [message, setMessage] = useState(null);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [pin, setPin] = useState("");
    const [confirmpin, setConfirmpin] = useState("");
    const [password, setPassword] = useState("");
    const [confirmpassword, setConfirmpassword] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const setMethod = { setFirstName, setLastName, setEmail, setMobile, setPin, setConfirmpin, setPassword, setConfirmpassword, setCaptcha, setMessage };
    const [success, setSuccess] = useState(false);

    const firstNameReference = useRef();
    const lastNameReference = useRef();
    const emailReference = useRef();
    const mobileReference = useRef();
    const pinReference = useRef();
    const confirmpinReference = useRef();
    const passwordReference = useRef();
    const confirmpasswordReference = useRef();
    const captchaReference = useRef();
    const termReference = useRef();
    
    const handleCheckBox = () => setIsChecked(!isChecked);

    function setCaptcha(value){
        captchaReference.current?.clearCaptcha(value);
    }

    function handleSubmit(event) {
        var captchaValue=captchaReference.current?.getCaptcha();
        var captchaImage=captchaReference.current?.getImage();
        var msg = '';
        if(msg==='') msg = validateName(event, firstNameReference,firstName,lastNameReference, lastName);
        if(msg==='') msg = validateEmail(event,emailReference,email);
        if(msg==='') msg = validateMobile(event,mobileReference,mobile);
        if(msg==='') msg = validateConfirmPin(event, pinReference,pin,confirmpinReference, confirmpin);
        if(msg==='') msg = validateConfirmPassword(event, passwordReference,password,confirmpasswordReference,confirmpassword);
        if(msg==='') msg = captchaReference.current?.validateCaptcha();
        if(msg==='') msg = validateTermsCheckBox(event,termReference,isChecked);
        setMessage(msg); 

        if(msg==='') {
            const data = {
                firstName: firstName,
                lastName: lastName,
                mobile: mobile.trim().startsWith("0")?mobile.trim().substring(1):mobile,
                emailId: email,
                pin : ''+encrypt(pin),
                confirmPin : ''+encrypt(confirmpin),
                password : ''+encrypt(password),
                confirmPasword : ''+encrypt(confirmpassword),
                captcha : ''+encrypt(captchaValue),
                checksum : ''+encrypt(captchaImage+(mobile.trim().startsWith("0")?mobile.trim().substring(1):mobile)+email),
            }
            axiosPost("/astrologer/add", data,
                (response)=>{
                    var ref = firstNameReference;
                    if(response.data.code==='101') {
                        ref = emailReference;
                    } else if(response.data.code==='102') {
                        ref = mobileReference;
                    } else if(response.data.code==='103') {
                        ref = pinReference;
                    } else if(response.data.code==='104') {
                        ref = termReference;
                    }
                    setMessage(axiosResponseHandler(response, ref, ()=>handleReset(setMethod,firstNameReference), "Your astrologer account is created successfully"));
                    if(response.data.code==='200') {
                        setSuccess(true);
                    }
                },
                (error)=>{
                    setMessage(axiosErrorHandler(firstNameReference,error));
                }
            );
        }
      
        event.preventDefault();

    }

    return (
        <div class="container text-start">
            <Title title="Sign Up" />
            <Message msg={message}/>
            {success===false?
            <form method="post" onSubmit={handleSubmit}>
                <FirstNameLastName title="Astrologer * " firstnamereference={firstNameReference} lastnamereference={lastNameReference} firstvalue={firstName} lastvalue={lastName} callback={(event)=>handleInput(event,setMethod)} />
                <Email reference={emailReference} data={email} callback={(event)=>handleInput(event,setMethod)} />
                <Mobile reference={mobileReference} data={mobile} callback={(event)=>handleInput(event,setMethod)} />
                <ConfirmPin reference={pinReference} confirmreference={confirmpinReference} value={pin} confirmvalue={confirmpin} callback={(event)=>handleInput(event,setMethod)} />
                <ConfirmPassword reference={passwordReference} confirmreference={confirmpasswordReference} value={password} confirmvalue={confirmpassword} callback={(event)=>handleInput(event,setMethod)} />
                <Captcha ref={captchaReference}/>
                <TermsCheckBox reference={termReference} isChecked={isChecked} callback={(event)=>handleCheckBox(event)} />
                <SubmitClearButton callback={()=>{handleReset(setMethod,firstNameReference);setIsChecked(false);} }/> 
            </form>
            :<SingleButton title="Ok"/>
            }
        </div> 
    );
    
}